import React, {useCallback} from 'react';
import translate from '../../utils/translations';
import {useFooterContext} from '../Footer/FooterContext';
import PropTypes from 'prop-types';

const svg = require('../../../static/images/hidden_content.svg');


const NoFunctionalCookies = ({ langcode }) => {
    const { dispatch, context: { showGdpr } } = useFooterContext();

    const onEnableFunctionalCookiesClick = useCallback(() => {
        const date = new Date();
        const expireDate = new Date(date.setMonth(date.getMonth() + 1));

        document.cookie = `functionalCookiesAccepted=true; expires=${expireDate}; path=/`;

        location = location;
    }, []);


    const onFunctionalCookiesImageClick = useCallback(() => {
        showGdpr || dispatch({
            type: 'SET_SHOW_GDPR',
            payload: true
        });
        dispatch({
            type: 'SET_GDPR_EXPANDED',
            payload: true
        });
    }, [showGdpr, dispatch]);

    return (
        <div className="func-cookies-container clear">
            <div className="func-cookies-text">
                {translate('PlsEnableFunctionalCookies', langcode)} ({translate('FunctionalDesc', langcode)})
            </div>
            <div className="func-cookies-button">
                <button
                    onClick={onEnableFunctionalCookiesClick}
                    className="btn btn-primary enable-functional-cookies"
                    type="button">
                        <span>{translate('EnableFunctionalCookies', langcode)}</span>
                    </button>
            </div>
            <div className="func-cookies-link">
                <a href="javascript:;" style={{cursor: "pointer"}} onClick={onFunctionalCookiesImageClick}>
                    <img alt="" src={svg?.['default']} className="func-cookies-img"/>
                </a>
            </div>
        </div>
    );
};

export default NoFunctionalCookies;

NoFunctionalCookies.propTypes = {
    langcode: PropTypes.string
};
